var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5504_4398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 8L39 16L39 32L24.5 40L10 32L10 16L24.5 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.2952L24.5 8.57105L38.5 16.2952L38.5 31.7048L24.5 39.4289L10.5 31.7048L10.5 16.2952Z",
    stroke: "#FF3939"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5173 28L20.3333 24.016C20.5493 23.784 20.7333 23.568 20.8853 23.368C21.0373 23.168 21.1533 22.968 21.2333 22.768C21.3133 22.568 21.3533 22.36 21.3533 22.144C21.3533 21.992 21.3253 21.844 21.2693 21.7C21.2133 21.556 21.1293 21.428 21.0173 21.316C20.9053 21.204 20.7693 21.116 20.6093 21.052C20.4493 20.98 20.2653 20.944 20.0573 20.944C19.7613 20.944 19.5053 21.016 19.2893 21.16C19.0813 21.296 18.9173 21.492 18.7973 21.748C18.6853 22.004 18.6293 22.3 18.6293 22.636H16.9493C16.9493 22.036 17.0693 21.496 17.3093 21.016C17.5493 20.536 17.9013 20.156 18.3653 19.876C18.8373 19.588 19.4133 19.444 20.0933 19.444C20.5973 19.444 21.0373 19.524 21.4133 19.684C21.7973 19.836 22.1133 20.04 22.3613 20.296C22.6173 20.544 22.8053 20.82 22.9253 21.124C23.0533 21.428 23.1173 21.732 23.1173 22.036C23.1173 22.484 23.0093 22.904 22.7933 23.296C22.5773 23.688 22.2933 24.044 21.9413 24.364L19.7573 26.428H23.2733V28H16.5173ZM24.7362 19.6H26.5002V28H24.7362V19.6ZM29.4882 19.6H31.5282L28.0482 23.536L31.7082 28H29.6202L25.9962 23.584L29.4882 19.6Z",
    fill: "#FF3939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5504_4398",
    x: 0,
    y: 0,
    width: 49,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5504_4398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5504_4398",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonimage);
export default __webpack_public_path__ + "static/media/hexagonimage.c3d3a0e936211fb11d0177f417b9ec0a.svg";
export { ForwardRef as ReactComponent };